import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "vr_cart_v1";

const readInitial = () => {
  try { const s = localStorage.getItem(KEY); return s ? JSON.parse(s) : []; }
  catch { return []; }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(readInitial);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch {}
  }, [items]);

  const add = (product, quantity = "1") => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.sku === product.sku);
      if (idx >= 0) return prev.map((i, k) => (k === idx ? { ...i, quantity } : i));
      return [...prev, { sku: product.sku, product_name: product.name, quantity, image: product.images?.[0] || null }];
    });
    setOpen(true);
  };
  const remove = (sku) => setItems((p) => p.filter((i) => i.sku !== sku));
  const updateQty = (sku, quantity) => setItems((p) => p.map((i) => (i.sku === sku ? { ...i, quantity } : i)));
  const clear = () => setItems([]);
  const count = items.length;

  return (
    <CartContext.Provider value={{ items, count, add, remove, updateQty, clear, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
